import { executeRequest, Request } from '@jfs/network'
import { refundsDetailsParserV3 } from './../network/parsers/refundDetailsParserV3'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const getRefundDetailsV3 = (
  tokens: any,
  userAccessToken: string,
  rrn: string,
  type: any,
  mid: string,
  txnType: any,
  isSmid: boolean,
) => {
  const refundRequest: Request<{}> = {
    apiPath: APIEndPoints.txnDetailsV3,
    method: 'POST',
    config: sitConfig(tokens),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    body: {
      inputFilter: {
        merchantId: mid,
        transactionType: type,
        originalTransactionId: [rrn],
        responseType: 'ALL',
        isSMID: isSmid ? 'Y' : 'N',
      },
      configParams: {
        mediaType: 'JSON',
      },
    },
  }
  return executeRequest(refundRequest).then((data) => {
    return refundsDetailsParserV3(data, txnType)
  })
}

export { getRefundDetailsV3 }
